import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Box, Button, Grid, Link, Tabs, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import { Container } from '@mui/system';
import { useEffect, useState } from 'react';
import * as React from 'react';
import Countdown from 'react-countdown';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import Popup990 from '@/components/ui/Form990Popup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

const Index = () => {
  // const [open, setOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 5, 15));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 5, 15)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);

  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
            color: '#d7d7d7',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  const [value, setValue] = React.useState('1');

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <AppLayout
      meta={
        <Meta
          title="E-filing IRS Tax Exempt Forms using TaxZerone®"
          description="Simplify the process of e-filing IRS Tax Exempt Org. Forms with TaxZerone, ensuring accuracy and convenience for tax-exempt organizations."
          keywords="IRS Tax Exempt Org. Forms, Exempt Org. Forms, Form 990 series, e-Postcard, Form 990-N, form 990, tax exempt forms, irs form 990"
          canonical="tax-exempt/"
          jsonLdPricing="9.90"
          jsonLdAggregateRatingValue="4.99"
          jsonLdAggregateRatingCount="2063"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <Popup990 />
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
        component="section"
      >
        <Box
          sx={{
            background: '#ffe400',
            p: 1.5,
            px: 2.5,
            color: '#444',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 16, sm: 17, md: 18, lg: '1.25rem' },
                lineHeight: 1.3,
              }}
            >
              <b style={{ color: '#c71f1f' }}>Attention Nonprofits! </b> E-file
              your
              <b> 2025 Form 990 Series</b> returns today and stay compliant with
              IRS requirements.
            </Typography>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time Left Until the Deadline{' '}
                <span style={{ fontWeight: 600 }}> (May 15, 2026)</span>:{' '}
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>

            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                size="large"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=homebanner`}
                sx={{
                  backgroundColor: '#c02652',
                  '&:hover, &:focus': {
                    backgroundColor: '#3e663b',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#fff',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-file Now!
              </Button>
              {/* <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                {' '}
                <b> Save 10%</b> with code{' '}
                <b style={{ color: '#c02652' }}> TZOTE10</b>
              </Typography> */}
            </Box>
          </Stack>
        </Box>
      </Container>

      <Box sx={{ maxWidth: 1920, mx: 'auto' }} component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="header"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-file{' '}
                <span className="highlight-container">
                  <span className="highlight">990 Forms</span>
                </span>{' '}
                for the 2025 tax year with the IRS securely and stay exempt.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                TaxZerone simplifies the IRS filing process for your nonprofit
                organization and helps you{' '}
                <span style={{ fontWeight: 600 }}>stay compliant</span> for the
                2025 tax year. With the simple and intuitive interface, complete
                your return filing and focus on your goal—making a difference in
                your community.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                  sx={{
                    mr: {
                      xs: 0,
                      md: 4,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    },
                  }}
                >
                  Start Filing Now
                </Button>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>

              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0}
                m={0}
                mt={{ xs: 2, md: 5 }}
                pb={0}
                textAlign="center"
                sx={{ ml: { xs: 0, md: -5 } }}
              >
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/secure-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/secure-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/secure-new-icon.png"
                          alt="Safe & Secure"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Safe &
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Secure
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/irs-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/irs-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/irs-new-icon.png"
                          alt="IRS Authorized"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      IRS
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Authorized
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 1, sm: 2 },
                      borderRadius: 0,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/lowest-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/lowest-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/lowest-new-icon.png"
                          alt="Affordable Price"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Affordable
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Filing Fee
                    </strong>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Hidden smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              className="exempt-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/exempt-tax-img.webp"
                  className="img-responsive-banner"
                />
                <source
                  srcSet="/assets/images/exempt-tax-img.png"
                  className="img-responsive-banner"
                />
                <img
                  src="/assets/images/exempt-tax-img.png"
                  alt="E-file Form 990-N & 8868 with the IRS securely"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          {/* <Hidden lgUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="exempt-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/exempt-tax-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/exempt-tax-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/exempt-tax-img-sm.png"
                  alt="E-file Form 990-N & 8868 with the IRS securely"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden> */}
        </Stack>
      </Box>
      <Box
        sx={{
          background: 'linear-gradient(220deg,#001435 69.7%,#003087 101.85%)',
        }}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 0, lg: 0 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 0, lg: 'auto' },
          }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box>
              <Box
                component="img"
                src="/assets/images/paypal-monotone.svg"
                sx={{
                  width: 176,
                  height: 45,
                }}
                alt="PayPal"
              />
            </Box>
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 26, md: 24, sm: 22, xs: 22 },
                  fontWeight: 700,
                  mb: 0,
                  textAlign: { xs: 'center', sm: 'left' },
                  lineHeight: 1.4,
                  color: '#1da94a',
                }}
              >
                Now Accepting PayPal
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#ccc',
                  mb: 0,
                  textAlign: { xs: 'center', sm: 'left' },
                  lineHeight: 1.4,
                }}
              >
                You can conveniently pay your filing fee using PayPal and other
                available payment methods.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: 110, sm: 110, md: 110 },
                textAlign: 'right',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#c02652',
                  color: '#fff',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#1da94a',
                  },
                }}
              >
                File Now
              </Button>
            </Box>
          </Stack>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          overflow: 'hidden',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={2}
            m={2}
            mt={5}
            pb={5}
            mb={{ xs: 5, sm: 5 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                E-file IRS forms for your nonprofit organization
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Choose TaxZerone for simple, quick, and secure e-file and stay
                tax compliant.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  position: 'relative',
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontSize: 24, fontWeight: 600 }}
                >
                  Form 990-N
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Electronic Notice (e-Postcard) for Tax-Exempt Organizations
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'center' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 25, sm: 29, md: 32 },
                          fontWeight: 700,
                          color: '#c02652',
                          fontStyle: 'normal',
                        }}
                      >
                        $9.90
                      </Typography>
                    </Typography>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          mb: 3.5,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                      >
                        E-file Form 990-N
                      </Button>
                    </Box>
                    {/* <Box
                      component={'span'}
                      sx={{
                        fontSize: { xs: 12, sm: 13, md: 14 },
                        fontWeight: 300,
                        color: '#444',
                        mt: -3,
                      }}
                    >
                      *Current tax year on or before the due date
                    </Box> */}
                  </Stack>
                </Box>{' '}
                <Box
                  component="span"
                  sx={{
                    position: 'absolute',
                    fontWeight: 500,
                    fontSize: '15px',
                    backgroundColor: '#0f0e0e',
                    color: '#fff',
                    display: 'block',
                    lineHeight: 1.5,
                    right: 0,
                    top: { md: 270, sm: 270, xs: 260 },
                    borderRadius: '30px 0 0 30px',
                    p: '7px 15px',
                    zIndex: 20,
                  }}
                >
                  Tax Year <br />
                  {previousYear}
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/990n-img.webp" />
                    <source srcSet="/assets/images/990n-img.png" />
                    <img
                      src="/assets/images/990n-img.png"
                      alt="990n"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  position: 'relative',
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontSize: 24, fontWeight: 600 }}
                >
                  Form 990-EZ
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <Link
                    href="/tax-exempt/e-file-irs-form-990-ez/"
                    sx={{ color: '#0202ff' }}
                  >
                    Short Form
                  </Link>{' '}
                  - Return of Organization Exempt From Income Tax with the IRS.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 25, sm: 29, md: 32 },
                          fontWeight: 700,
                          color: '#c02652',
                          fontStyle: 'normal',
                        }}
                      >
                        $89.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                      >
                        E-File Form 990-EZ
                      </Button>
                    </Box>
                    <Box
                      component="span"
                      sx={{
                        position: 'absolute',
                        fontWeight: 500,
                        fontSize: '15px',
                        backgroundColor: '#0f0e0e',
                        color: '#fff',
                        display: 'block',
                        lineHeight: 1.5,
                        right: 0,
                        top: { md: 264, sm: 260, xs: 275 },
                        borderRadius: '30px 0 0 30px',
                        p: '7px 15px',
                        zIndex: 20,
                        textAlign: 'center',
                      }}
                    >
                      Tax Year <br />
                      {previousYear}
                    </Box>
                    <Box
                      component="span"
                      sx={{
                        fontSize: { xs: 12, sm: 13, md: 14 },
                        fontWeight: 300,
                        color: '#444',
                        minHeight: 21,
                      }}
                    />
                  </Stack>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/990-ez-img.webp" />
                    <source srcSet="/assets/images/990-ez-img.png" />
                    <img
                      src="/assets/images/990-ez-img.png"
                      alt="Form 990-EZ"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  position: 'relative',
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontSize: 24, fontWeight: 600 }}
                >
                  Form 990
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Return of{' '}
                  <Link
                    href="/tax-exempt/e-file-irs-form-990/"
                    sx={{ color: '#0202ff' }}
                  >
                    Organization Exempt
                  </Link>{' '}
                  From Income Tax
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 25, sm: 29, md: 32 },
                          fontWeight: 700,
                          color: '#c02652',
                          fontStyle: 'normal',
                        }}
                      >
                        $179.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                      >
                        E-File Form 990
                      </Button>
                    </Box>
                    <Box
                      component="span"
                      sx={{
                        fontSize: { xs: 12, sm: 13, md: 14 },
                        fontWeight: 300,
                        color: '#444',
                        minHeight: 21,
                      }}
                    />
                  </Stack>
                </Box>
                <Box
                  component="span"
                  sx={{
                    position: 'absolute',
                    fontWeight: 500,
                    fontSize: '15px',
                    backgroundColor: '#0f0e0e',
                    color: '#fff',
                    display: 'block',
                    lineHeight: 1.5,
                    right: 0,
                    top: { md: 270, sm: 270, xs: 260 },
                    borderRadius: '30px 0 0 30px',
                    p: '7px 15px',
                    zIndex: 20,
                  }}
                >
                  Tax Year <br />
                  {previousYear}
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/990-img.webp" />
                    <source srcSet="/assets/images/990-img.png" />
                    <img
                      src="/assets/images/990-img.png"
                      alt="Form 990"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  position: 'relative',
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontSize: 24, fontWeight: 600 }}
                >
                  Form 990-PF
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 1, minHeight: { md: 72 } }}
                >
                  Return of{' '}
                  <Link
                    href="/tax-exempt/e-file-irs-form-990-pf/"
                    sx={{ color: '#0202ff' }}
                  >
                    Private Foundation
                  </Link>{' '}
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 25, sm: 29, md: 32 },
                          fontWeight: 700,
                          color: '#c02652',
                          fontStyle: 'normal',
                        }}
                      >
                        $149.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                      >
                        E-File Form 990-PF
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="span"
                  sx={{
                    position: 'absolute',
                    fontWeight: 500,
                    fontSize: '15px',
                    backgroundColor: '#0f0e0e',
                    color: '#fff',
                    display: 'block',
                    lineHeight: 1.5,
                    right: 0,
                    top: { md: 264, sm: 218, xs: 209 },
                    borderRadius: '30px 0 0 30px',
                    p: '7px 15px',
                    zIndex: 20,
                  }}
                >
                  Tax Year <br />
                  {previousYear}
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/990-pf-img.webp" />
                    <source srcSet="/assets/images/990-pf-img.png" />
                    <img
                      src="/assets/images/990-pf-img.png"
                      alt="990pf"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  position: 'relative',
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontSize: 24, fontWeight: 600 }}
                >
                  Form 990-T
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 1, minHeight: { md: 72 } }}
                >
                  Exempt Organization{' '}
                  <Link
                    href="/tax-exempt/e-file-irs-form-990-t/"
                    sx={{ color: '#0202ff' }}
                  >
                    Unrelated Business Income Tax Return
                  </Link>{' '}
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 25, sm: 29, md: 32 },
                          fontWeight: 700,
                          color: '#c02652',
                          fontStyle: 'normal',
                        }}
                      >
                        $129.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                      >
                        E-File Form 990-T
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="span"
                  sx={{
                    position: 'absolute',
                    fontWeight: 500,
                    fontSize: '15px',
                    backgroundColor: '#0f0e0e',
                    color: '#fff',
                    display: 'block',
                    lineHeight: 1.5,
                    right: 0,
                    top: { md: 264, sm: 240, xs: 230 },
                    borderRadius: '30px 0 0 30px',
                    p: '7px 15px',
                    zIndex: 20,
                  }}
                >
                  Tax Year <br />
                  {previousYear}
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/990-t-img.webp" />
                    <source srcSet="/assets/images/990-t-img.png" />
                    <img
                      src="/assets/images/990-t-img.png"
                      alt="990-t"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  position: 'relative',
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontSize: 24, fontWeight: 600 }}
                >
                  CA FTB - Form 199
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 1, minHeight: { md: 72 } }}
                >
                  <Link
                    href="/tax-exempt/efile-ftb-ca-form199-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    California Exempt Organization
                  </Link>{' '}
                  Annual Information Return
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 25, sm: 29, md: 32 },
                          fontWeight: 700,
                          color: '#c02652',
                          fontStyle: 'normal',
                        }}
                      >
                        $69.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                      >
                        E-File Form 199
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="span"
                  sx={{
                    position: 'absolute',
                    fontWeight: 500,
                    fontSize: '15px',
                    backgroundColor: '#0f0e0e',
                    color: '#fff',
                    display: 'block',
                    lineHeight: 1.5,
                    right: 0,
                    top: { md: 264, sm: 240, xs: 230 },
                    borderRadius: '30px 0 0 30px',
                    p: '7px 15px',
                    zIndex: 20,
                  }}
                >
                  Tax Year <br />
                  {previousYear}
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/ca-199-img.webp" />
                    <source srcSet="/assets/images/ca-199-img.png" />
                    <img
                      src="/assets/images/ca-199-img.png"
                      alt="CA FTB - Form 199"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  position: 'relative',
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontSize: 24, fontWeight: 600 }}
                >
                  Form 5227
                </Typography>
                <Typography variant="body1" sx={{ mt: 0, mb: 8 }}>
                  <Link
                    href="/tax-exempt/e-file-irs-form-5227/"
                    sx={{ color: '#0202ff' }}
                  >
                    Split-Interest Trust Information Return
                  </Link>{' '}
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 25, sm: 29, md: 32 },
                          fontWeight: 700,
                          color: '#c02652',
                          fontStyle: 'normal',
                        }}
                      >
                        $179.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                      >
                        E-file Form 5227
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="span"
                  sx={{
                    position: 'absolute',
                    fontWeight: 500,
                    fontSize: '15px',
                    backgroundColor: '#0f0e0e',
                    color: '#fff',
                    display: 'block',
                    lineHeight: 1.5,
                    right: 0,
                    top: { md: 264, sm: 270, xs: 280 },
                    borderRadius: '30px 0 0 30px',
                    p: '7px 15px',
                    zIndex: 20,
                  }}
                >
                  Tax Year <br />
                  {previousYear}
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/5227-form-img.webp" />
                    <source srcSet="/assets/images/5227-form-img.png" />
                    <img
                      src="/assets/images/5227-form-img.png"
                      alt="Form 5227"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  position: 'relative',
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontSize: 24, fontWeight: 600 }}
                >
                  Form 1120-POL
                </Typography>
                <Typography variant="body1" sx={{ mt: 0, mb: 8 }}>
                  <Link
                    href="/tax-exempt/e-file-irs-form-1120-pol/"
                    sx={{ color: '#0202ff' }}
                  >
                    U.S. Income Tax Return for Certain Political Organizations
                  </Link>{' '}
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 25, sm: 29, md: 32 },
                          fontWeight: 700,
                          color: '#c02652',
                          fontStyle: 'normal',
                        }}
                      >
                        $49.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                      >
                        E-file Form 1120-POL
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="span"
                  sx={{
                    position: 'absolute',
                    fontWeight: 500,
                    fontSize: '15px',
                    backgroundColor: '#0f0e0e',
                    color: '#fff',
                    display: 'block',
                    lineHeight: 1.5,
                    right: 0,
                    top: { md: 264, sm: 270, xs: 280 },
                    borderRadius: '30px 0 0 30px',
                    p: '7px 15px',
                    zIndex: 20,
                  }}
                >
                  Tax Year <br />
                  {previousYear}
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/1120-pol-form-img.webp" />
                    <source srcSet="/assets/images/1120-pol-form-img.png" />
                    <img
                      src="/assets/images/1120-pol-form-img.png"
                      alt="Form 5227"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  p: 2,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                  position: 'relative',
                  '&:hover, &:focus, &:active': { borderColor: '#989898' },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontSize: 24, fontWeight: 600 }}
                >
                  Form 8868
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Application for an automatic 6-month extension of time to file
                  an{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    exempt organization return
                  </Link>{' '}
                  with the IRS.
                </Typography>
                <Box sx={{ mb: 3 }}>
                  <Stack
                    direction={{
                      xs: 'column',
                      sm: 'column',
                      md: 'column',
                    }}
                    spacing={{ xs: 1, sm: 1, md: 1 }}
                    sx={{
                      mt: 2,
                      justifyContent: { xs: 'center', sm: 'flex-start' },
                      textAlign: { xs: 'center', md: 'left' },
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        fontStyle: 'italic',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      component="div"
                    >
                      Only&nbsp;
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: 25, sm: 29, md: 32 },
                          fontWeight: 700,
                          color: '#213e99',
                          fontStyle: 'normal',
                        }}
                      >
                        $14.99
                      </Typography>
                    </Typography>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          textAlign: 'center',
                          textTransform: 'none',
                          borderRadius: 4,
                          boxShadow: 'none',
                          px: 3,
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          transition: 'all 0.3s ease 0s',
                          '&:hover, &:focus, &:active': {
                            transform: 'scale(1.1)',
                            boxShadow: 'none',
                          },
                        }}
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                      >
                        E-file Form 8868
                      </Button>
                    </Box>
                  </Stack>
                </Box>
                <Box
                  component="span"
                  sx={{
                    position: 'absolute',
                    fontWeight: 500,
                    fontSize: '15px',
                    backgroundColor: '#0f0e0e',
                    color: '#fff',
                    display: 'block',
                    lineHeight: 1.5,
                    right: 0,
                    top: { md: 264, sm: 270, xs: 280 },
                    borderRadius: '30px 0 0 30px',
                    p: '7px 15px',
                    zIndex: 20,
                  }}
                >
                  Tax Year <br />
                  {previousYear}
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/8868-img.webp" />
                    <source srcSet="/assets/images/8868-img.png" />
                    <img
                      src="/assets/images/8868-img.png"
                      alt="Form 8868"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" component="section">
        <Grid
          container
          spacing={2}
          sx={{ mt: { xs: 2, sm: 6, md: 8 }, mb: 3 }}
          className="MuiGrid-root-width"
        >
          <Grid size={12} textAlign="center">
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Maximize Your Tax-Exempt Organization&apos;s
              <Hidden smDown>
                <br />
              </Hidden>{' '}
              Credits with Form 990-T
            </Typography>
            <Box
              component="div"
              sx={{ maxWidth: 900, textAlign: 'center', mx: 'auto' }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 1,
                  textAlign: 'center',
                }}
              >
                If your tax-exempt organization earns{' '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  unrelated business taxable income (UBTI),
                </span>{' '}
                it may be required to{' '}
                <Link
                  href="/tax-exempt/e-file-irs-form-990-t/"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  file IRS Form 990-T
                </Link>
                . When filing Form 990-T, eligible organizations may claim
                certain{' '}
                <span style={{ fontWeight: 600 }}>
                  federal business tax credits
                </span>{' '}
                to help reduce their income tax liability.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                To properly claim these credits, the organization must complete
                the applicable IRS credit forms and report them on{' '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  Form 3800 (General Business Credit),
                </span>{' '}
                which is then attached to{' '}
                <span style={{ fontWeight: 600 }}>Form 990-T.</span>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg" component="section">
        <Box sx={{ width: '100%' }}>
          <TabContext value={value}>
            <Box
              sx={{
                borderRadius: 8,
                p: '5px', // 👈 IMPORTANT: small padding creates visible border
                backgroundImage:
                  'linear-gradient(#fff, #fff), linear-gradient(215deg, rgb(29,183,121) 0%, rgb(152,70,230) 100%)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                border: '2px solid transparent',
                maxWidth: 550,
                mx: 'auto',
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                centered
                sx={{
                  color: '#000000',
                  textTransform: 'normal',
                  rowGap: 2,
                  backgroundColor: '#ffffff',
                  px: 0.5,
                  borderRadius: 8,

                  '& .MuiTabs-indicator': {
                    // border: '#78e41a 2px solid',
                    backgroundColor: 'transparent !important',
                    height: 48,
                    borderRadius: 8,
                    // zIndex: 2,
                    // transition:
                    //   'transform 350ms cubic-bezier(0.4, 0, 0.2, 1), width 800ms cubic-bezier(0.4, 0, 0.2, 1)',
                    transition:
                      'transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    // transition: 'transform 300ms ease, width 300ms ease',
                  },
                  '& .Mui-selected': {
                    color: '#ffffff !important',
                    backgroundColor: '#1da94a !important',
                    transition: 'all 0.5s ease',
                    // boxShadow: '0 4px 8px rgba(10, 10, 10, 0.3)',
                  },
                  '& .MuiButtonBase-root': {
                    transition: 'all 0.5s ease',
                  },
                  // '& .MuiTab-root:active': {
                  //   boxShadow: '0 2px 14px rgba(29,169,74,0.6)',
                  //   transform: 'scale(0.97)',
                  // },

                  '& .MuiTab-root': {
                    textTransform: 'none',
                    backgroundColor: '#edebeb',
                    border: '2px solid #ccc',
                    borderRadius: 8,
                    color: '#333',
                    transition:
                      'transform 0.25s ease, background-color 0.3s ease, color 0.3s ease',
                  },
                  '& .MuiTab-root:hover': {
                    transform: 'translateY(0px)', // lift
                  },

                  '& .MuiTab-root:active': {
                    transform: 'scale(0.95)', // press
                  },
                  '& .MuiTabs-flexContainer': {
                    m: 'auto',
                    display: { xs: 'grid', sm: 'flex' },
                    // textAlign: 'center',
                    justifyContent: 'center',
                    // alignItems: 'center',
                    alignSelf: 'center',
                    gridTemplateColumns: {
                      xs: 'repeat(2, 1fr)',
                      sm: 'repeat(4, 1fr)',
                    },
                    gap: { xs: 1, sm: 2, md: 3 },
                  },
                }}
              >
                <Tab
                  label="Form 3800"
                  value="1"
                  sx={{
                    backgroundColor: '#edebeb',
                    border: '1px solid #ccc',
                    borderRadius: 8,
                    color: '#333',
                  }}
                />
                <Tab
                  label="Form 3468 "
                  value="2"
                  sx={{
                    backgroundColor: '#edebeb',
                    border: '1px solid #ccc',
                    borderRadius: 8,
                    color: '#333',
                  }}
                />
                <Tab
                  label="Form 8911"
                  value="3"
                  sx={{
                    backgroundColor: '#edebeb',
                    border: '1px solid #ccc',
                    borderRadius: 8,
                    color: '#333',
                  }}
                />
                <Tab
                  label="Form 8936 "
                  value="4"
                  sx={{
                    backgroundColor: '#edebeb',
                    border: '1px solid #ccc',
                    borderRadius: 8,
                    color: '#333',
                  }}
                />
              </Tabs>
            </Box>
            <Box sx={{ position: 'relative', minHeight: 600 }}>
              <Box
                sx={{
                  position: 'absolute',
                  width: '100%',
                  opacity: value === '1' ? 1 : 0,
                  // transition: 'opacity 0.4s ease',
                  pointerEvents: value === '1' ? 'auto' : 'none',
                  transform:
                    value === '1' ? 'translateY(0)' : 'translateY(10px)',
                  transition: 'opacity 0.4s ease, transform 0.4s ease',
                }}
              >
                <TabPanel value="1">
                  <Stack
                    spacing={2}
                    direction="row"
                    sx={{
                      backgroundColor: '#f0f2f9',
                      maxWidth: '100%',
                      p: 3,
                      borderRadius: { xs: 0, md: 4 },
                      // mx: { xs: 0, md: 3, lg: 'auto' },
                      my: { xs: 2, sm: 2, md: 2 },
                      justifyContent: 'center',
                      alignItems: 'center',
                      // minHeight: '100%',
                      height: { xs: '800px', sm: '590px', md: '600' },
                      minHeight: 600,
                    }}
                  >
                    <Box
                      sx={{
                        mr: '16px !important',
                        position: 'relative',
                        zIndex: 10,
                        left: { md: 10 },
                      }}
                    >
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { md: 22, sm: 18, xs: 16 },
                          textAlign: 'left',
                          fontWeight: 600,
                        }}
                      >
                        Form 3800
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: { md: 18, sm: 17, xs: 16 },
                          fontWeight: 500,
                          textAlign: 'left',
                          mb: 2,
                        }}
                      >
                        General Business Credit
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Allows organizations to calculate, combine, and claim
                        eligible federal business tax credits from multiple IRS
                        credit forms and apply them against the income tax
                        reported on Form 990-T when unrelated business taxable
                        income exists.
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Form 3800 applies IRS limitations, determines allowable
                        credit amounts for the current year, and tracks any
                        unused credits that may be carried forward to future tax
                        years. This form must be attached to Form 990-T.
                      </Typography>
                      <Box
                        sx={{
                          p: 1,
                          borderLeft: '3px solid #be2450',
                          backgroundColor: '#fffdfe',
                          borderRadius: 3,
                        }}
                      >
                        <Typography variant="body2">
                          <span style={{ fontWeight: 600 }}> Examples:</span>{' '}
                          Investment Credit (Form 3468), Alternative Fuel
                          Vehicle Refueling Property Credit (Form 8911), Clean
                          Vehicle Credit (Form 8936), and other eligible general
                          business credits.
                        </Typography>
                      </Box>
                      <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Button
                          variant="contained"
                          sx={{
                            mt: { xs: 2, sm: 4 },
                            mb: { xs: 2, sm: 2, md: 2 },
                            textTransform: 'none',
                            fontSize: '16px',
                            px: 3,
                            py: 1.2,
                            borderRadius: 4,
                            boxShadow: 'none',
                            transition: 'transform 0.3s ease',
                            '&:hover, &:focus, &:active': {
                              transform: 'scale(1.1)',
                              boxShadow: 'none',
                              px: 3,
                              fontSize: '16px',
                            },
                          }}
                          // className="btn-primary-sec"
                          href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                        >
                          E-file Now
                        </Button>
                      </Box>
                    </Box>
                    <Hidden mdDown>
                      <Box
                        component="div"
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%',
                          textAlign: { xs: 'center', md: 'right' },
                          // my: { xs: 3, md: 0 },
                          position: 'relative',
                          right: { md: -24 },
                        }}
                      >
                        <picture>
                          <source
                            srcSet="/assets/images/exempt-credit-img.webp"
                            className="img-responsive"
                            width={550}
                            height={500}
                          />
                          <source
                            srcSet="/assets/images/exempt-credit-img.png"
                            className="img-responsive"
                            width={550}
                            height={500}
                          />
                          <img
                            src="/assets/images/exempt-credit-img.png"
                            alt="General Business Credit"
                            className="img-responsive"
                            loading="lazy"
                            width={550}
                            height={500}
                          />
                        </picture>
                      </Box>
                    </Hidden>
                  </Stack>
                </TabPanel>
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  width: '100%',
                  opacity: value === '2' ? 1 : 0,
                  // transition: 'opacity 0.4s ease',
                  pointerEvents: value === '2' ? 'auto' : 'none',
                  transform:
                    value === '2' ? 'translateY(0)' : 'translateY(10px)',
                  transition: 'opacity 0.4s ease, transform 0.4s ease',
                }}
              >
                <TabPanel value="2">
                  <Stack
                    spacing={2}
                    direction="row"
                    sx={{
                      backgroundColor: '#f0f2f9',
                      p: 3,
                      borderRadius: { xs: 0, md: 4 },
                      // mx: { xs: 0, md: 3, lg: 'auto' },
                      my: { xs: 2, sm: 2, md: 2 },
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '100%',
                      height: '590px',
                    }}
                  >
                    <Box
                      sx={{
                        mr: '16xp !important',
                        position: 'relative',
                        zIndex: 10,
                        left: { md: 10 },
                      }}
                    >
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { md: 22, sm: 18, xs: 16 },
                          textAlign: 'left',
                          fontWeight: 600,
                          mb: 2,
                        }}
                      >
                        Form 3468
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: { md: 18, sm: 17, xs: 16 },
                          fontWeight: 500,
                          textAlign: 'left',
                          mb: 2,
                        }}
                      >
                        Investment Credit
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Allows organizations to claim credits for investments in
                        energy property, new equipment, and qualified
                        rehabilitation expenditures.
                      </Typography>

                      <Box
                        sx={{
                          p: 1,
                          borderLeft: '3px solid #be2450',
                          backgroundColor: '#fffdfe',
                          borderRadius: 3,
                        }}
                      >
                        <Typography variant="body2">
                          <span style={{ fontWeight: 600 }}> Examples:</span>{' '}
                          Manufacturing semiconductors, Energy Storage
                          facilities, Solor Energy properties, small wind energy
                          properties.
                        </Typography>
                      </Box>
                      <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Button
                          variant="contained"
                          sx={{
                            mt: { xs: 2, sm: 4 },
                            mb: { xs: 2, sm: 2, md: 2 },
                            textTransform: 'none',
                            fontSize: '16px',
                            px: 3,
                            py: 1.2,
                            borderRadius: 4,
                            boxShadow: 'none',
                            transition: 'transform 0.3s ease',
                            '&:hover, &:focus, &:active': {
                              transform: 'scale(1.1)',
                              boxShadow: 'none',
                              px: 3,
                              fontSize: '16px',
                            },
                          }}
                          // className="btn-primary-sec"
                          href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                        >
                          E-file Now
                        </Button>
                      </Box>
                    </Box>
                    <Hidden mdDown>
                      <Box
                        component="div"
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%',
                          textAlign: { xs: 'center', md: 'right' },
                          // my: { xs: 3, md: 0 },
                          position: 'relative',
                          right: { md: -24 },
                        }}
                      >
                        <picture>
                          <source
                            srcSet="/assets/images/f3468-investment-img.webp"
                            className="img-responsive"
                            width={550}
                            height={500}
                          />
                          <source
                            srcSet="/assets/images/f3468-investment-img.png"
                            className="img-responsive"
                            width={550}
                            height={500}
                          />
                          <img
                            src="/assets/images/f3468-investment-img.png"
                            alt="Investment Credit"
                            className="img-responsive"
                            loading="lazy"
                            width={550}
                            height={500}
                          />
                        </picture>
                      </Box>
                    </Hidden>
                  </Stack>
                </TabPanel>
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  width: '100%',
                  opacity: value === '3' ? 1 : 0,
                  // transition: 'opacity 0.4s ease',
                  pointerEvents: value === '3' ? 'auto' : 'none',
                  transform:
                    value === '3' ? 'translateY(0)' : 'translateY(10px)',
                  transition: 'opacity 0.4s ease, transform 0.4s ease',
                }}
              >
                <TabPanel value="3">
                  <Stack
                    spacing={2}
                    direction="row"
                    sx={{
                      backgroundColor: '#f0f2f9',
                      p: 3,
                      borderRadius: { xs: 0, md: 4 },
                      // mx: { xs: 0, md: 3, lg: 'auto' },
                      my: { xs: 2, sm: 2, md: 2 },
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '100%',
                      height: '590px',
                    }}
                  >
                    <Box
                      sx={{
                        mr: '16xp !important',
                        position: 'relative',
                        zIndex: 10,
                        left: { md: 10 },
                      }}
                    >
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { md: 22, sm: 18, xs: 16 },
                          textAlign: 'left',
                          fontWeight: 600,
                          mb: 2,
                        }}
                      >
                        Form 8911
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: { md: 18, sm: 17, xs: 16 },
                          fontWeight: 500,
                          textAlign: 'left',
                          mb: 2,
                        }}
                      >
                        Alternative Fuel Vehicle Refueling Property Credit
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Allows your organization to determine the credit for
                        alternative fuel vehicle refueling property placed in
                        service during the tax year.
                      </Typography>

                      <Box
                        sx={{
                          p: 1,
                          borderLeft: '3px solid #be2450',
                          backgroundColor: '#fffdfe',
                          borderRadius: 3,
                        }}
                      >
                        <Typography variant="body2">
                          <span style={{ fontWeight: 600 }}> Examples:</span>{' '}
                          Qualifying examples include electric vehicle (EV)
                          charging stations, hydrogen refueling stations,
                          biodiesel refueling property, and ethanol or natural
                          gas refueling infrastructure.
                        </Typography>
                      </Box>
                      <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Button
                          variant="contained"
                          sx={{
                            mt: { xs: 2, sm: 4 },
                            mb: { xs: 2, sm: 2, md: 2 },
                            textTransform: 'none',
                            fontSize: '16px',
                            px: 3,
                            py: 1.2,
                            borderRadius: 4,
                            boxShadow: 'none',
                            transition: 'transform 0.3s ease',
                            '&:hover, &:focus, &:active': {
                              transform: 'scale(1.1)',
                              boxShadow: 'none',
                              px: 3,
                              fontSize: '16px',
                            },
                          }}
                          // className="btn-primary-sec"
                          href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                        >
                          E-file Now
                        </Button>
                      </Box>
                    </Box>
                    <Hidden mdDown>
                      <Box
                        component="div"
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%',
                          textAlign: { xs: 'center', md: 'right' },
                          // my: { xs: 3, md: 0 },
                          position: 'relative',
                          right: { md: -24 },
                        }}
                      >
                        <picture>
                          <source
                            srcSet="/assets/images/f8911-fuel-img.webp"
                            className="img-responsive"
                            width={550}
                            height={500}
                          />
                          <source
                            srcSet="/assets/images/f8911-fuel-img.png"
                            className="img-responsive"
                            width={550}
                            height={500}
                          />
                          <img
                            src="/assets/images/f8911-fuel-img.png"
                            alt="Alternative Fuel Vehicle Refueling Property Credit"
                            className="img-responsive"
                            loading="lazy"
                            width={550}
                            height={500}
                          />
                        </picture>
                      </Box>
                    </Hidden>
                  </Stack>
                </TabPanel>
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  width: '100%',
                  opacity: value === '4' ? 1 : 0,
                  // transition: 'opacity 0.4s ease',
                  pointerEvents: value === '4' ? 'auto' : 'none',
                  transform:
                    value === '1' ? 'translateY(0)' : 'translateY(10px)',
                  transition: 'opacity 0.4s ease, transform 0.4s ease',
                }}
              >
                <TabPanel value="4">
                  <Stack
                    spacing={2}
                    direction="row"
                    sx={{
                      backgroundColor: '#f0f2f9',
                      p: 3,
                      borderRadius: { xs: 4, md: 4 },
                      // mx: { xs: 0, md: 3, lg: 'auto' },
                      my: { xs: 2, sm: 2, md: 2 },
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '100%',
                      height: '590px',
                    }}
                  >
                    <Box
                      sx={{
                        mr: '16xp !important',
                        position: 'relative',
                        zIndex: 10,
                        left: { md: 10 },
                      }}
                    >
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { md: 22, sm: 18, xs: 16 },
                          textAlign: 'left',
                          fontWeight: 600,
                          mb: 2,
                        }}
                      >
                        Form 8936
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: { md: 18, sm: 17, xs: 16 },
                          fontWeight: 500,
                          textAlign: 'left',
                          mb: 2,
                        }}
                      >
                        Clean Vehicle Credits
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Enables your organization to determine the applicable
                        credit for clean vehicles placed in service during the
                        tax year, including new clean vehicles, previously owned
                        clean vehicles, and qualified commercial clean vehicles.
                      </Typography>

                      <Box
                        sx={{
                          p: 1,
                          borderLeft: '3px solid #be2450',
                          backgroundColor: '#fffdfe',
                          borderRadius: 3,
                        }}
                      >
                        <Typography variant="body2">
                          <span style={{ fontWeight: 600 }}> Examples:</span>{' '}
                          Electric cars (EVs), clean-fuel trucks, electric vans,
                          and electric buses.
                        </Typography>
                      </Box>
                      <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Button
                          variant="contained"
                          sx={{
                            mt: { xs: 2, sm: 4 },
                            mb: { xs: 2, sm: 2, md: 2 },
                            textTransform: 'none',
                            fontSize: '16px',
                            px: 3,
                            py: 1.2,
                            borderRadius: 4,
                            boxShadow: 'none',
                            transition: 'transform 0.3s ease',
                            '&:hover, &:focus, &:active': {
                              transform: 'scale(1.1)',
                              boxShadow: 'none',
                              px: 3,
                              fontSize: '16px',
                            },
                          }}
                          // className="btn-primary-sec"
                          href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                        >
                          E-file Now
                        </Button>
                      </Box>
                    </Box>
                    <Hidden mdDown>
                      <Box
                        component="div"
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%',
                          textAlign: { xs: 'center', md: 'right' },
                          // my: { xs: 3, md: 0 },
                          position: 'relative',
                          right: { md: -24 },
                        }}
                      >
                        <picture>
                          <source
                            srcSet="/assets/images/f8936-clean-img.webp"
                            className="img-responsive"
                            width={550}
                            height={500}
                          />
                          <source
                            srcSet="/assets/images/f8936-clean-img.png"
                            className="img-responsive"
                            width={550}
                            height={500}
                          />
                          <img
                            src="/assets/images/f8936-clean-img.png"
                            alt="Clean Vehicle Credits"
                            className="img-responsive"
                            loading="lazy"
                            width={550}
                            height={500}
                          />
                        </picture>
                      </Box>
                    </Hidden>
                  </Stack>
                </TabPanel>
              </Box>
            </Box>
          </TabContext>
        </Box>
      </Container>

      <Box
        sx={{ backgroundColor: '#f0f2f9', my: { xs: 3, sm: 6, md: 8 } }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 0 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 5,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to e-file IRS forms for your nonprofit organization
                <Hidden smDown>
                  <br />
                </Hidden>{' '}
                using TaxZerone?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Follow the simple steps below to e-file IRS forms and stay tax
                compliant.
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/exempt-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/exempt-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/exempt-steps-img.png"
                  alt="How to e-file IRS forms for your nonprofit organization using TaxZerone?"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Select the form you want to file"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Select the form you want to file.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Fill out the form information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Fill out the form information.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Review and transmit the form to the IRS"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review and transmit the form to the IRS.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-4-icon.webp" />
                        <source srcSet="/assets/images/step-4-icon.png" />
                        <img
                          src="/assets/images/step-4-icon.png"
                          alt="Get notified when the IRS accepts your form"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Get notified when the IRS accepts your form.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 21, md: 20, sm: 18, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                Ready to stay tax compliant?
              </Typography>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: { xs: 2, sm: 4 },
                    mb: { xs: 2, sm: 2, md: 5 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
                >
                  E-file Now
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>

      <Grid
        container
        sx={{
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={0}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Top reasons to choose TaxZerone for nonprofit e-filing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Get countless benefits by filing IRS forms with TaxZerone.
                However, here are the top benefits.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            sx={{ justifyContent: 'center', p: 0, listStyleType: 'none' }}
            component="ul"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Easy e-filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy e-filing
                </Typography>
                <Typography variant="body1">
                  File your tax return easily and hassle-free. With our
                  user-friendly interface, you can quickly enter your tax
                  details and submit your return within minutes.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided filing
                </Typography>
                <Typography variant="body1">
                  Our step-by-step instructions will guide you to complete your
                  return accurately, minimizing the chances of rejection. Stay
                  assured that your tax return is filed the first time
                  correctly.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/smart-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/smart-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/smart-icon.png"
                      alt="Smart validations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart validations
                </Typography>
                <Typography variant="body1">
                  We&apos;ll validate your returns for errors in your tax
                  return. You can correct any errors before transmitting your
                  return, reducing the chances of rejection.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12} component="li">
                &nbsp;
              </Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="Quick and secure e-filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Quick and secure e-filing
                </Typography>
                <Typography variant="body1">
                  File IRS forms online with TaxZerone in just 5 minutes and
                  transmit your return to the IRS securely. It&apos;s that
                  simple.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Get Instant Form Updates"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Get Instant Form Updates
                </Typography>
                <Typography variant="body1">
                  Receive instant status notifications by email as soon as the
                  IRS processes your return. You can also check the return
                  status from your TaxZerone account.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/free-efile-retransmission-icon.png"
                      alt="Free retransmission of rejected returns"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Free retransmission of rejected returns
                </Typography>
                <Typography variant="body1">
                  Even if the IRS rejects your form due to any reason, you can
                  correct and retransmit it to the IRS for free. No additional
                  charges.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          E-file IRS forms with TaxZerone & stay tax compliant
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Make the e-filing process simple and hassle-free by clicking the
          button below.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=exempt`}
          >
            Start E-filing
          </Button>
        </Box>
      </Box>

      <Container
        maxWidth="lg"
        component="section"
        aria-labelledby="exempt-organization-faqs"
      >
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              id="exempt-organization-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              FAQs on Exempt Organization
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  When is a tax-exempt organization required to file Form 990-T?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 0.5 }}>
                    A tax-exempt organization must{' '}
                    <Link
                      href="/tax-exempt/e-file-irs-form-990-t/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      file Form 990-T
                    </Link>{' '}
                    if it has{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      $1,000 or more in gross income from unrelated business
                      activities
                    </span>{' '}
                    during the tax year. This requirement applies even if the
                    organization ultimately owes no tax.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is Form 3800 and why is it required?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography variant="body1">
                      <span style={{ fontWeight: 600 }}>
                        Form 3800 (General Business Credit)
                      </span>{' '}
                      is used to:{' '}
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>Combine multiple eligible business tax credits</li>
                      <li>Apply IRS credit limitations</li>
                      <li>
                        Determine the allowable credit for the current year
                      </li>
                      <li>Track unused credit carryforwards</li>
                    </Box>
                    <Typography variant="body1">
                      If a tax-exempt organization claims general business
                      credits, Form 3800 must be attached to Form 990-T.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Can I request an extension to file Form 990?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 0.8 }}>
                    <span style={{ fontWeight: 600 }}> Yes.</span> To request
                    more time to file Form 990, you must{' '}
                    <Link
                      href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      file Form 8868
                    </Link>{' '}
                    on or before your original due date. Filing Form 8868 grants
                    an
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      automatic 6-month extension
                    </span>{' '}
                    for most exempt organizations. Remember, this extends the
                    filing deadline only—not the time to pay any tax due.
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-990/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Index;
